import DefaultConfig from "../shop/simde";

export default class Config extends DefaultConfig {
    botChatDomain = 'staging-chat.sim.de';
    agentChatDomain = 'staging-livechat.sim.de'
    trademarkWebsite = 'https://staging-www.sim.de';
}
